package dev.inmo.wishlist.features.ui.adminPanel.ui

import dev.inmo.wishlist.features.common.client.models.ViewConfig
import kotlinx.serialization.Serializable

/** Navigation config for the admin wishlists list screen. */
@Serializable
class AdminWishlistsListViewConfig : ViewConfig
